import { FC } from "react";

import { copy } from "shared/assets";
import { Calendar, ListBullets } from "shared/assets/icons";
import { Action } from "shared/components";
import { Spacer } from "shared/layout";

import { useCalendarContext, ViewKeys } from "Bands/contexts";

interface ViewToggleProps {}

export const ViewToggle: FC<ViewToggleProps> = () => {
  const { view, setView } = useCalendarContext();

  return (
    <Spacer spaceDirection="horizontal" size="s">
      <Action
        icon={Calendar}
        label={copy.calendar.viewToggle.calendar}
        isActive={view === ViewKeys.calendar}
        handleClick={() => setView(ViewKeys.calendar)}
        dataTestId="calendar_view_button"
      />
      <Action
        icon={ListBullets}
        label={copy.calendar.viewToggle.list}
        isActive={view === ViewKeys.list}
        handleClick={() => setView(ViewKeys.list)}
        dataTestId="list_view_button"
      />
    </Spacer>
  );
};
